// Dependencies
import React from 'react'

// Styles
import {
  Container,
  ContentWrapper,
  BannerImageWrapper,
  TextContentWrapper,
  Title,
  BannerImage
} from './banner.styles'

// Types
import { BannerProps } from './banner.types'

export const Banner: React.FunctionComponent<BannerProps> = ({
  title,
  content,
  imageSource,
  imageOrientation
}) => {
  return (
    <Container imageOrientation={imageOrientation}>
      <TextContentWrapper>
        <Title>{title}</Title>

        <ContentWrapper>{content}</ContentWrapper>
      </TextContentWrapper>

      <BannerImageWrapper>
        <BannerImage src={imageSource} />
      </BannerImageWrapper>
    </Container>
  )
}

export default Banner
